import React from 'react';
import { Form } from 'semantic-ui-react';
import Editor, { Props as EditorProps } from 'src/components/custom/Editor';

export type Props = {
  placeholder?: string;
  label?: string;
  value?: string;
  error?: string;
} & EditorProps;

const EditorField: React.FC<Props> = (props) => {
  const { label, error, ...rest } = props;

  return (
    <Form.Field>
      <label>{label}</label>
      <Editor {...rest} />
      {error && <div className="ui pointing above prompt label">{error}</div>}
    </Form.Field>
  );
};

export default EditorField;
